// Copyright (c) 2016 Deere & Company

import classNames from '../../shared/constants/ag-grid-class-names';
import {translate} from '../../../shared/services/translation-service';

export function getLaborStatsColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'partNumber',
            field: 'partNumber',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PART_NUMBER'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'partFamily',
            field: 'partFamily',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PART_FAMILY'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'repairReplaceText',
            field: 'repairReplaceText',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('REPAIR_REPLACE_INDICATOR'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'averageRepairHours',
            field: 'averageRepairHours',
            filter: 'number',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('AVERAGE_REPAIR_HOURS'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'repairOccurancesNumber',
            field: 'repairOccurancesNumber',
            filter: 'number',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('NUMBER_OF_REPAIR_OCCURRENCES'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'averageReplacementHours',
            field: 'averageReplacementHours',
            filter: 'number',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('AVERAGE_REPLACEMENT_HOURS'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'replacementOccurancesNumber',
            field: 'replacementOccurancesNumber',
            filter: 'number',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('NUMBER_OF_REPLACEMENT_OCCURRENCES'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'averageDiagonsticsHours',
            field: 'averageDiagonsticsHours',
            filter: 'number',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('AVERAGE_DIAGNOSTICS_HOURS'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'diagnosticOccurancesNumber',
            field: 'diagnosticOccurancesNumber',
            filter: 'number',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('NUMBER_OF_DIAGNOSTICS_OCCURRENCES'),
            width: 200
        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/labor-stats/report-services/column-definitions.js